import { useMutation } from '@apollo/client'
import { CREATE_USER_REVIEW_MUTATION } from '../api/meals/mutations/createUserReview'
import { trackEventReview } from '../utils/rating'
import { useOnboardingStatus } from './useOnboardingStatus'

interface ReviewInput {
  rating: number
  comment?: string
  reasons?: string[]
}

export const useCreateUserReview = () => {
  const { onboardingStatus, refetch } = useOnboardingStatus()
  const [createReview, { loading, error }] = useMutation(
    CREATE_USER_REVIEW_MUTATION
  )

  const submitReview = async (
    product: { id: string },
    orderId: string,
    review: ReviewInput
  ) => {
    try {
      const { data } = await createReview({
        variables: {
          product: product.id,
          order: Number(orderId),
          review: review.comment ?? '',
          rating: review.rating,
          reasons: review.reasons
        }
      })

      if (!data?.createUserReview) {
        return { success: false, error: 'Failed to create review' }
      }

      const rateMealsStep = onboardingStatus?.find(
        step => step.name === 'rate_meals'
      )

      if (
        !onboardingStatus ||
        onboardingStatus.length === 0 ||
        (rateMealsStep && !rateMealsStep.completed)
      ) {
        refetch()
      }

      trackEventReview(product, review, data.createUserReview.id)
      return { success: true, review: data.createUserReview }
    } catch (err) {
      console.error('Error creating review:', err)
      return { success: false, error: err }
    }
  }

  return {
    submitReview,
    loading,
    error
  }
}
